// Static content for STRAßENWERT label
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_neon-beats-label/artifacts/vhioznbo_Gemini_Generated_Image_5d3kx25d3kx25d3k-removebg-preview.png";

export const SERVICES = [
  {
    code: "MGT",
    title: "Künstlermanagement",
    price: "ab 15%",
    sub: "Beteiligungsmodell",
    description:
      "Strategische Karriereführung, Verträge, Booking, Release-Planung und Tour-Koordination. 24/7 für die Künstler unseres Rosters.",
    bullets: ["Vertragsverhandlung", "Karriereplanung", "Booking & Touring", "Finanz-Struktur"],
  },
  {
    code: "SMM",
    title: "Social Media Marketing",
    price: "ab 890 €",
    sub: "monatlich",
    description:
      "Content-Strategie, Ads-Management, Community Building auf Instagram, TikTok & YouTube. Organisch + Performance.",
    bullets: ["Content Planung", "Meta & TikTok Ads", "Community Management", "Analytics & Reports"],
  },
  {
    code: "PRM",
    title: "Promotion & PR",
    price: "ab 2.500 €",
    sub: "pro Single Cycle",
    description:
      "Multi-Channel Promo Push: Editorial Pitching, Radio & DSP Plugging, Blog-Features und Medien-Outreach.",
    bullets: ["Spotify Pitching", "Radio Promo", "Editorial Features", "PR & Coverage"],
  },
  {
    code: "CNT",
    title: "Content Creation",
    price: "ab 1.200 €",
    sub: "pro Drop-Paket",
    description:
      "Cinematic Visuals, Performance Content, Behind-the-Scenes, Vertical Cuts. In-House Kamera- & Editing-Team.",
    bullets: ["Music Videos", "Visualizer & Cover", "Reels & Shorts", "Documentary Cuts"],
  },
  {
    code: "NET",
    title: "Networking",
    price: "auf Anfrage",
    sub: "Retainer-Modell",
    description:
      "Zugang zu unserem gewachsenen Netzwerk: Produzenten, Features, Brands, DSP-Kontakte, Medien & Agenturen.",
    bullets: ["Feature-Vermittlung", "Brand Deals", "DSP-Kontakte", "Event & Szene"],
  },
  {
    code: "STR",
    title: "Strategie",
    price: "ab 1.200 €",
    sub: "monatlich",
    description:
      "Brand-Architektur, Positioning, Visual Identity Roadmap. Wir bauen dich nicht als Rapper – wir bauen dich als Marke.",
    bullets: ["Brand Identity", "Content Roadmap", "Audience Strategy", "Markt-Analyse"],
  },
  {
    code: "VTM",
    title: "Vertrieb & Marketing",
    price: "ab 499 €",
    sub: "pro Release",
    description:
      "Digitaler Vertrieb auf alle relevanten DSPs + paralleles Marketing-Rollout: Pre-Save, Teaser, Launch, Longtail.",
    bullets: ["Distribution (DSPs)", "Pre-Save Kampagnen", "Launch Plan", "Longtail Marketing"],
  },
];

export const ARTISTS = [
  {
    name: "NONO",
    tag: "Gangsterrap / Berlin",
    image:
      "https://customer-assets.emergentagent.com/job_neon-beats-label/artifacts/ksg04mxw_image.png",
  },
];

// Studios im Aufbau – kein Roster, Instagram-Handles zum Folgen
export const STUDIOS_SOON = {
  handles: [
    { tag: "@strassenwert", url: "https://instagram.com/strassenwert" },
    { tag: "@strassenwert.studios", url: "https://instagram.com/strassenwert.studios" },
  ],
};

export const STATS = [
  { label: "Künstler im Aufbau", value: "4", note: "Aktives Roster" },
  { label: "Releases in Arbeit", value: "13", note: "Q1 / Q2 Pipeline" },
  { label: "Netzwerk Partner", value: "52", note: "DSPs · Medien · Brands" },
  { label: "Content Output", value: "320+", note: "Visuals / Jahr" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1646812949032-d63e95a484a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1762599107111-ce63cc521897?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

// Founder portrait — used on /geschichte and as About image fallback
export const FOUNDER_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_neon-beats-label/artifacts/2powx47n_image.png";
